import { type SelectionsMachine } from '../../../machine/selection-machine.ts';
import { type SharedEventLoop } from '../../event-loop.ts';
import { type SelectionUiInteractionHandler } from '../../selection-ui-interaction.ts';
import { type SelectionInput } from '../../types.ts';
import { createKeyboardInputFor } from '../create-keyboard-input-for.ts';

import { handleTableCellActionsKeyDown } from './handle-table-cell-actions-key-down.ts';

/**
 * Creates the table keyboard input for legacy focused-cell actions.
 *
 * This input intentionally owns only edit/clear/deselect actions. Table
 * movement, range extension, and traversal should live in dedicated keyboard
 * inputs so those behaviors can be gated and tested independently.
 */
export function createTableCellActionsInput(
  machine: SelectionsMachine,
  sharedLoop: SharedEventLoop,
  options: {
    onSelectionUiInteraction?: SelectionUiInteractionHandler;
  } = {}
): SelectionInput {
  return createKeyboardInputFor(machine, sharedLoop, {
    handler: (capture, selectionMachine) =>
      handleTableCellActionsKeyDown(
        capture,
        selectionMachine,
        options.onSelectionUiInteraction
      )
  });
}
